var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSingleRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"chevron right\""
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.6766 15.6561C20.7666 16.5661 20.7666 18.0361 21.6766 18.9461L30.73 27.9995L21.6766 37.0528C20.7666 37.9628 20.7666 39.4328 21.6766 40.3428C22.5866 41.2528 24.0566 41.2528 24.9666 40.3428L35.6766 29.6328C36.5866 28.7228 36.5866 27.2528 35.6766 26.3428L24.9666 15.6328C24.08 14.7461 22.5866 14.7461 21.6766 15.6561Z",
    fill: "#6B2C90"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleRightArrow);
export default __webpack_public_path__ + "static/media/SingleRightArrow.d8715abfb502eb0dd7a73657682d11ea.svg";
export { ForwardRef as ReactComponent };